import React from 'react'

import ArticleItem from '@molecules/ArticleItem'
import { ArticleWithHit } from '@src/components/Hits'
import { Article } from '@models/Article'

import * as style from './style.module.sass'

export type ArticleListProps = {
  articles: Article[] | ArticleWithHit[]
  gtmClickType: string
  gtmLabel?: string
  handleArticleClick?: (article: Article | ArticleWithHit) => void
}

const ArticleList: React.FC<ArticleListProps> = ({
  articles,
  gtmClickType,
  gtmLabel,
  handleArticleClick,
}) => (
  <div className={style.list}>
    {articles.map(article => (
      <div
        className={style.articleContainer}
        key={article.blogId}
        data-gtm-click={`article-list-${gtmClickType}`}
        data-gtm-label={gtmLabel}
        data-gtm-value={article.blogId}
        onClick={() => {
          handleArticleClick?.(article)
        }}
      >
        <ArticleItem
          article={article}
          listRule="smallTab"
          gtmClickType={gtmClickType}
        />
      </div>
    ))}
  </div>
)

export default ArticleList
